import { combineReducers } from 'redux';
import accessData from './accessDataReducer';
import login from './loginReducer';

export default combineReducers({
    accessData,
    login,
});



// WEBPACK FOOTER //
// ./src/reducers/authReducer/index.js